import { Chip, styled } from "@mui/material";

import { palette } from "~frontend/theme";

const TagChip = styled(Chip)({
  fontSize: "12px",
  color: palette.darkGreen,
  backgroundColor: palette.midGreen,
  height: "initial",
  "& .MuiChip-label": { padding: "2px 6px" },
});

export default TagChip;
